/**
 *
 * CheckpointOperatorView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';

function CheckpointOperatorView({ dataTable, formDialog, viewName, viewStyles }) {
  return (
    <div style={viewStyles.root}>
      <Paper style={viewStyles.dataTable}>
        {
          React.cloneElement(dataTable, { viewName })
        }
      </Paper>
      { formDialog }
    </div>
  );
}

CheckpointOperatorView.propTypes = {
  dataTable: PropTypes.node.isRequired,
  formDialog: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  viewStyles: PropTypes.object,
};

CheckpointOperatorView.defaultProps = {
  viewStyles: {},
};

export default CheckpointOperatorView;
